import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import generalActions from 'redux/actions/generalActions'
import Modalizer from 'components/modalizer/modalizer'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import { LessonPreview } from 'components/iframe'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import styles from './lesson_preview_modal.scss'
import { localize } from 'helpers/translator'

const LessonPreviewModal = props => (
	<Modalizer modalName={props.modalName} width='708px' height='585px' closeAction={() => props.actions.closeModal(props.modalName)}>
		<SecondaryTitle isCentered={true}>{localize('lesson_preview_modal_secondaty_title')}</SecondaryTitle>
		<div styleName='preview-container'>
			<LessonPreview entityUID={props.entityUID} bundleId={props.bundleId} privateLibraryId={props.privateLibraryId} />
		</div>
	</Modalizer>
)

LessonPreviewModal.propTypes = {
	modalName: PropTypes.string,
	entityUID: PropTypes.string,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(LessonPreviewModal, styles, {allowMultiple: true}))
